import 'bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css';

import './App.scss';

import Navigation from './navigation';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { useEffect, useRef } from 'react';
import { requestForToken, onMessageListener } from './firebase';
import { AreaProvider } from './context/AreaContext';
const App = () => {
  const navigate = useNavigate();
  const lastToastRef = useRef<string | null>(null);
  const lastToastTimeRef = useRef<number>(0);

  const showToast = (message: string, orderId?: string) => {
    const now = Date.now();
    if (message === lastToastRef.current && now - lastToastTimeRef.current < 3000) {
      console.log('Duplicate toast prevented:', message);
      return;
    }
    lastToastRef.current = message;
    lastToastTimeRef.current = now;
    toast(message, { 
        toastId: message,
        onClick: () => {
            if (orderId) {
                console.log('Toast clicked, navigating to order:', orderId);
                navigate('/payment-details', { state: { orderId } });
            }
        },
        closeOnClick: true,
        autoClose: 5000
    });
  };

  useEffect(() => {
    requestForToken();
    
    const unsubscribeFromMessage = onMessageListener((payload: any) => {
      const message = payload?.notification?.body || payload?.data?.body;
     
      const orderId = payload?.data?.order_id || payload?.data?.orderId;
     

      if (message) {
        showToast(message, orderId);
      }
    });

    // Handle Service Worker broadcasts
    const messageHandler = (event: MessageEvent) => {
        if (event.data && typeof event.data === 'object') {
             const payload = event.data;
             
             // Handle explicit notification click event from SW
             if (payload.type === 'NOTIFICATION_CLICK') {
                 console.log('Notification clicked (from SW)', payload);
                 const orderId = payload.order_id || payload.orderId;
                 if (orderId) {
                     navigate('/payment-details', { state: { orderId } });
                 } else {
                     console.error('Missing orderId in NOTIFICATION_CLICK payload');
                 }
                 return;
             }

             const message = payload?.notification?.body || payload?.data?.body || payload?.body;
             const orderId = payload?.data?.order_id || payload?.data?.orderId || payload?.order_id || payload?.orderId;

             if(message){
                  console.log('Source: SW Broadcast', payload);
                  showToast(message, orderId);
             }
        }
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', messageHandler);
    }

    return () => {
        if(unsubscribeFromMessage){
            unsubscribeFromMessage();
        }
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.removeEventListener('message', messageHandler);
        }
    };
  }, []);
  return (
    <>
      <div className="App">
        <AreaProvider>
          <Navigation />
        </AreaProvider>
        <ToastContainer />
      </div>

    </>
  );
};
export default App;
